import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-two-columns-four-page',
  templateUrl: './courses-grid-style-two-columns-four-page.component.html',
  styleUrls: ['./courses-grid-style-two-columns-four-page.component.scss']
})
export class CoursesGridStyleTwoColumnsFourPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
